import { Button } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";

import { RanaModal } from "@nens/ranalib";

import { AppDispatch } from "../App";
import { backToStartScreen } from "../state/appState";
import { inactivateModal } from "../state/mainGui";
import { getSimulationDuration, startSimulation } from "../state/simulation";

const LeaveSession: React.FC<Props> = (props) => {
  const simulationDuration = useSelector(getSimulationDuration);

  const hours = Math.floor(simulationDuration / (60 * 60));
  const mins = Math.ceil((simulationDuration % (60 * 60)) / 60);

  let hoursStr = hours + "";
  if (hoursStr.length === 1) {
    hoursStr = "0" + hoursStr;
  }
  let minsStr = mins + "";
  if (minsStr.length === 1) {
    minsStr = "0" + minsStr;
  }

  return (
    <RanaModal
      isOpen={true}
      topBar={
        <FormattedMessage id="leave_modal.title_leave_session" defaultMessage="Leave session?" />
      }
      onClose={props.inactivateModal}
      buttons={[
        <Button variant="secondary" onClick={props.inactivateModal}>
          <FormattedMessage id="leave_modal.cancel_button" defaultMessage="Cancel" />
        </Button>,
        <Button
          variant="primary"
          onClick={() => {
            props.backToStartScreen();
          }}
        >
          <FormattedMessage id="leave_modal.leave_button" defaultMessage="Leave session" />
        </Button>,
      ]}
    >
      <span>
        <FormattedMessage
          id="leave_modal.continue_simulation_untill"
          defaultMessage="The simulation will keep running until virtual time reaches hh:mm: "
        />
        <span>
          {hoursStr}:{minsStr}
        </span>
      </span>
    </RanaModal>
  );
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    inactivateModal: () => dispatch(inactivateModal()),
    backToStartScreen: () => dispatch(backToStartScreen()),
    startSimulation: () => dispatch(startSimulation()),
  };
};
type Props = ReturnType<typeof mapDispatchToProps>;

export default connect(null, mapDispatchToProps)(LeaveSession);
